// extracted by mini-css-extract-plugin
export default {"fontSize":"LoginButton_fontSize__oAYAr","loginBtn":"LoginButton_loginBtn__lH93t","loginButtonImgWrapper":"LoginButton_loginButtonImgWrapper__r69Sz"};